// import * as Masonry from 'masonry-layout';
import $ from 'jquery';
import justifiedGallery from 'justifiedGallery';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

export const photoGalleries = document.querySelectorAll('.gallery-grid, .gallery_grid');
export const carouselGalleries = document.querySelectorAll('.gallery-carousel, .gallery-inline, .gallery_row, .gallery-row');

export class photoGallery {	
	constructor() {
		photoGalleries.forEach(function (el) {
			console.log('Photo gallery:');
			console.log(el);
			console.log(el.dataset)

			// Set row height
			let height = el.dataset.height ? el.dataset.height : 180;
			console.log(height);

			// Set margin size
			let margin = el.dataset.margin ? el.dataset.margin : 5;

			// Set container border
			let border = el.dataset.border ? el.dataset.border : margin;

			// Justify last row
			let justify = el.dataset.justify == "true" ? "justify" : "nojustify";
			console.log(el.dataset.justify == "true")
			console.log(justify)

			// Enable/disable lightbox (enabled by default)
			let lightbox = el.dataset.lightbox == "false" ? false : true; 
	
			// const gallery = new Masonry(el, {
			// 	// initLayout: false,
			// 	itemSelector: '.grid-item',
			// 	columnWidth: '.grid-sizer',
			// 	gutter: 6
			// });
	
			// Remove legacy .grid-sizer element
			if (el.querySelector('.grid-sizer')) {
				el.querySelector('.grid-sizer').remove();
			}

			// Initialize Justified Gallery (justified brick layout)
			$(el).justifiedGallery({
				captions: false,
				lastRow: justify,
				rowHeight: height,
				margins: margin,
				border: border
			})
				.on("jg.complete", function () {
					console.log('justifiedGallery complete')

					// Enable lightbox
					if (lightbox) {
						// Selector element (accounts for legacy HTML)
						let itemSelector = el.querySelector('.grid-item') ? '.grid-item' : '.gallery-item';
						// Initialize lightGallery (image detail)
						lightGallery(el, {
							licenseKey: '221087FC-1B85-47F8-B1AB-1F7080677FB3',
							selector: itemSelector,
							plugins: [lgZoom, lgThumbnail],
							download: false,
							allowMediaOverlap: false
						});
					}
				});

		});

		// Carousel gallery 
		carouselGalleries.forEach(function (el) {
			console.log('Carousel gallery:', el);

			// Selector elements (accounts for legacy Swiper HTML)
			let containerSelector = el.classList.contains('swiper-container') ? '.gallery_row .swiper-wrapper' : el;
			let itemSelector = el.classList.contains('swiper-container') ? '.swiper-slide' : '.gallery-item';

			const carouselGallery = lightGallery(el, {
				licenseKey: '221087FC-1B85-47F8-B1AB-1F7080677FB3',
				container: containerSelector,
				selector: itemSelector,
				plugins: [lgZoom, lgThumbnail],
				closable: true,
				download: false,
				allowMediaOverlap: false
			});

			carouselGallery.openGallery(0);
		});
	}

}

if (photoGalleries != undefined || carouselGalleries != undefined) new photoGallery();